// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__qCR7A {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
}

.styles_input__74AA8 {
  position: relative;
  height: 16px;
  padding-left: 14px;
  color: transparent;
  border: 1px solid #414141;
  border-radius: 2px;
  appearance: none;
  outline: 0;
  cursor: pointer;
}
.styles_input__74AA8::before, .styles_input__74AA8::after {
  position: absolute;
  content: "";
  display: block;
  width: 0;
  background: white;
  border-style: solid;
  border-color: #ffffff;
  border-width: 1px;
  border-radius: 16px;
  opacity: 0;
}
.styles_input__74AA8::before {
  display: block;
  top: 5px;
  left: 3px;
  height: 5px;
  transform: rotate(315deg);
}
.styles_input__74AA8::after {
  top: 2px;
  left: 7px;
  height: 9px;
  transform: rotate(45deg);
}
.styles_input__74AA8:checked {
  color: #ffffff;
  border-color: #ff136d;
  background: #ff136d;
}
.styles_input__74AA8:checked::before, .styles_input__74AA8:checked::after {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/checkbox/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AADF;;AAIA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;AADF;AAGE;EAEE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBC5BI;ED6BJ,iBAAA;EACA,mBAAA;EACA,UAAA;AAFJ;AAKE;EACE,cAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;AAHJ;AAME;EACE,QAAA;EACA,SAAA;EACA,WAAA;EACA,wBAAA;AAJJ;AAOE;EACE,cClDI;EDmDJ,qBCzCG;ED0CH,mBC1CG;ADqCP;AAOI;EAEE,UAAA;AANN","sourcesContent":["@import './src/assets/styles/variables/colors';\n\n.wrapper {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.input {\n  position: relative;\n  height: 16px;\n  padding-left: 14px;\n  color: transparent;\n  border: 1px solid $grey-input;\n  border-radius: 2px;\n  appearance: none;\n  outline: 0;\n  cursor: pointer;\n\n  &::before,\n  &::after {\n    position: absolute;\n    content: '';\n    display: block;\n    width: 0;\n    background: white;\n    border-style: solid;\n    border-color: $white;\n    border-width: 1px;\n    border-radius: 16px;\n    opacity: 0;\n  }\n\n  &::before {\n    display: block;\n    top: 5px;\n    left: 3px;\n    height: 5px;\n    transform: rotate(315deg);\n  }\n\n  &::after {\n    top: 2px;\n    left: 7px;\n    height: 9px;\n    transform: rotate(45deg);\n  }\n\n  &:checked {\n    color: $white;\n    border-color: $pink;\n    background: $pink;\n\n    &::before,\n    &::after {\n      opacity: 1;\n    }\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__qCR7A`,
	"input": `styles_input__74AA8`
};
export default ___CSS_LOADER_EXPORT___;
